<template>
    <div class="EvTable" ref="EvTable">
        <v-table
        :height="height"
        :table-data="data"
        :columns="columnsList"
        :is-horizontal-resize="true"
        :column-width-drag="true"
        :column-width-drag-resize="columnWidthDragResize"
        :show-sort="showSort"
        :multiple-sort="multipleSort"
        :sort-always="sortAlways"
        style="width:100%"
        :tableBgColor="tableBgColor"
        :title-bg-color="titleBgColor"
        :odd-bg-color="oddBgColor"
        :even-bg-color="evenBgColor"
        :row-hover-color="rowHoverColor"
        :row-click-color="rowClickColor"
        :row-click="rowClick"
        :row-dblclick="rowDblclick"
        :column-cell-class-name="columnCellClassName"
        :show-vertical-border="showVerticalBorder"
        :show-horizontal-border="showHorizontalBorder"
        :title-row-height="titleRowHeight"
        :row-height="rowHeight"
        :footer-row-height="footerRowHeight"
        :cell-edit-done="cellEditDone"
        :select-change="selectChange"
        :select-all="selectAll"
        :is-loading="isLoading"
        :errorContent="noDataText"
        @click-row="clickRow"
        @sort-change="sortChange"
        ></v-table>
    </div>
</template>
<script>
    // import boxMixin from "../boxMixin.js";
    import EvTableMixin from "./EvTableMixin.js";

    // const platData = window.platDataMap ? window.platDataMap[window.platDataMap.name] : {};
    // const tableStyle = platData.evtableStyle || {};
    export default {
        name: "EvTable",
        mixins: [
            // boxMixin,
            EvTableMixin
        ],
        props: {
            data: Array,
            columnsList: Array,
            columnWidthDragResize: Function,
            tableBgColor: {
                type: String,
                default: () => {
                    return "#fff";
                    // return tableStyle.tableBgColor || "#fff";
                }
            },
            titleBgColor: {
                type: String,
                default: () => {
                    return "#FAFBFD";
                    // return tableStyle.titleBgColor || "#FAFBFD";
                }
            },
            oddBgColor: {
                type: String,
                default: () => {
                    return "#fff";
                    // return tableStyle.oddBgColor || "#fff";
                }
            },
            evenBgColor: {
                type: String,
                default: () => {
                    return "#F7F9FC";
                    // return tableStyle.evenBgColor || "#F7F9FC";
                }
            },
            rowHoverColor: {
                type: String,
                default: () => {
                    return "#F1F4FA";
                    // return tableStyle.rowHoverColor || "#F1F4FA";
                }
            },
            rowClickColor: {
                type: String,
                default: () => {
                    return "#F1F4FA";
                    // return tableStyle.rowClickColor || "#F1F4FA";
                }
            },
            // 表体单元格设置className
            columnCellClassName: {
                type: Function,
                default: () => {
                    return () => {
                        return "column-cell-class-name";
                    };
                }
            },
            // 是否显示垂直border,false 时列拖动失效
            showVerticalBorder: {
                type: Boolean,
                default: () => {
                    return true;
                }
            },
            showHorizontalBorder: {
                type: Boolean,
                default: () => {
                    return false;
                }
            },
            titleRowHeight: {
                type: Number,
                default: 52
            },
            // 内容行高
            rowHeight: {
                type: Number,
                default: 52
            },
            footerRowHeight: {
                type: Number,
                default: 52
            },
            showSort: {
                type: Boolean
            },
            multipleSort: {
                type: Boolean,
                default: false
            },
            sortAlways: {
                type: Boolean,
                default: false
            },
            isLoading: {
                type: Boolean,
                default: false
            },
            height: Number,
            noDataText: {
                type: String,
                default: "暂无数据..."
            }
        },
        data () {
            return {};
        },
        created () {},
        mounted () {},
        methods: {
            clickRow (row, index) {
                this.$emit("click-row", row, index);
            }
        }
    };
    </script>

    <style lang="less">
    .EvTable{
        width: 100%;
        height: 100%;
        overflow: auto;
        font-size: 14px;
        box-shadow: 0px 4px 20px 0px rgba(0,0,0,0.1);
        border: 0;
        .v-table{
            &-views {
                border: 0;
                box-shadow:0px 4px 20px 0px rgba(0,0,0,0.1);
            }
            .v-table-rightview .vertical-border {
                border-right-width: 0px !important;
            }
            .v-table-leftview .vertical-border{
                border-right-width: 0px !important;
            }
            &-title-cell{
                padding: 0 15px;
                border-color: #F1F4FA;
                .table-title{
                    padding: 0;
                }
            }
            &-header{
                font-weight: bold;
                color: rgba(93,93,93,1);
                letter-spacing: 2px;
                font-size: 14px;
            }
            &-body{
                font-weight:400;
                color:rgba(135,135,135,1);
            }
            &-body-cell{
                padding: 0 15px;
                color: #666666;
                border-color: #F1F4FA;
            }
            &-empty-inner{
                border-top: 1px solid rgba(221, 221, 221, 1);
            }
        }
        .v-scrollbar-wrap{
            &::-webkit-scrollbar{
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb{
                background: #E1E8ED;
                border-radius: 3px;
            }
        }
        .v-table-empty-scroll{
            &::-webkit-scrollbar{
                width: 6px;
                height: 6px;
            }
            &::-webkit-scrollbar-thumb{
                background: #E1E8ED;
                border-radius: 3px;
            }
        }

        &::-webkit-scrollbar{
            // width: 4px;
            width: 6px;
            height: 6px;
        }
        &::-webkit-scrollbar-thumb{
            background: #E1E8ED;
            border-radius: 3px;
        }
        // etable 多条关联等带框的样式
        .EvTable-box {
            width: auto;
            height: 24px;
            margin-top: 7px;
            padding: 5px;
            line-height: 12px;
            display: inline-block;
            background: #f2f8ff;
            border-radius: 2px;
            border: 1px solid #6daef2;
            font-size: 12px!important;
            color: #6DAEF2;
            cursor: pointer;

            overflow: hidden;
            word-break: keep-all;
            white-space: nowrap;
            text-overflow: ellipsis;
            i {
                margin-right: 5px;
                font-size: 12px!important;
            }
        }
    }
    </style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/list/evTable/EvTable.vue